import { ErrorHandler, Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class ErrorService extends ErrorHandler {

  public static error?: Error;

  constructor(private readonly zone: NgZone, public router: Router) {
    super();
  }

  public override handleError(error: any): void {
    if (error.rejection) {
      error = error.rejection;
    }
    ErrorService.error = error;
    if (error instanceof ForbiddenError) {
      setTimeout(() => {
        this.zone.run(() => {
          this.router.navigate(['/error'], { skipLocationChange: true });
        });
      });
    } else {
      // Pour les autres erreurs, laisse Angular gérer (console, stacktrace, etc.)
      super.handleError(error);
    }
  }
}

export class ForbiddenError extends Error { }

